import { Box } from "@mui/material";
import {
	DAY_GRID_COLUMNS,
	GRID_BORDER,
	HOURS_PER_DAY,
} from "../utils/dayHourGrid";

const headerCellSx = {
	backgroundColor: "#ffffff",
	textAlign: "left",
	fontWeight: 500,
	fontSize: 10,
	color: "#64748b",
	py: 0.5,
	pl: "3px",
	fontVariantNumeric: "tabular-nums",
	borderBottom: GRID_BORDER,
};

type Props = {
	/** hour column to outline as current; null on the tomorrow board */
	nowHour: number | null;
	hoveredHour: number | null;
	onHourHover: (hour: number | null) => void;
};

/** Labels assume clock hours, so they drift a hair on DST days; the cell
 *  buckets below stay exact. */
export const DayHourHeader = ({ nowHour, hoveredHour, onHourHover }: Props) => (
	<Box
		sx={{ display: "grid", gridTemplateColumns: DAY_GRID_COLUMNS }}
		onMouseLeave={() => onHourHover(null)}
	>
		<Box sx={{ ...headerCellSx, borderRight: GRID_BORDER }} />
		{Array.from({ length: HOURS_PER_DAY }, (_, h) => (
			<Box
				key={h}
				onMouseEnter={() => onHourHover(h)}
				sx={{
					...headerCellSx,
					...(h === hoveredHour && { backgroundColor: "#EDEDED" }),
					...(h === nowHour && {
						outline: (theme: { palette: { primary: { main: string } } }) =>
							`2px solid ${theme.palette.primary.main}`,
						outlineOffset: "-2px",
						zIndex: 2,
						color: "primary.main",
						fontWeight: 700,
					}),
				}}
			>
				{`${h}`.padStart(2, "0")}:00
			</Box>
		))}
	</Box>
);
